#ifdef GL_ES
precision highp float;
#endif

#define FREQUENCY 58.0
#define RADIUS 0.35

varying vec2 vTextureCoord;
varying vec2 vActiveTextureCoord;

// custom uniforms
uniform float uDotFade;

// our textures samplers
uniform sampler2D uTexture;

float checkBlackness(vec4 color) {
  return dot(color.rgb, vec3(0.2126, 0.7152, 0.0722));
}

vec3 rgb(float r, float g, float b) {
  float limit = 255.0;
  return vec3(r/limit, g/limit, b/limit);
}

void main() {
  vec2 vUv = vTextureCoord;

  vec2 sampleUvCurrent = vec2(floor(vActiveTextureCoord * FREQUENCY)/FREQUENCY);

  // Normalize UV
  vec2 nearest = fract(FREQUENCY * vUv);
  nearest *= 2.0;
  nearest -= 1.0;

  float dist = length(nearest);

  vec4 frameTexture = texture2D(uTexture, sampleUvCurrent);
  float frameBlackness = checkBlackness(frameTexture);

  // Color
  vec3 white = vec3(1.0, 1.0, 1.0);
  vec3 black = vec3(0.0, 0.0, 0.0);
  vec3 gray = rgb(15.0, 15.0, 15.0);

  vec3 fadeWhite = mix(gray, white, uDotFade);
  vec3 mixColor = mix(fadeWhite, black, step(0.9, frameBlackness));
  vec3 fragcolor = mix(mixColor, black, step(RADIUS, dist));

  float dotOpacity = floor((1.0 - step(0.9, frameBlackness)));

  gl_FragColor = vec4(fragcolor, dotOpacity);
}

